import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';
import { TrackingReplayPageSkeleton } from '@cobliteam/tracking/src/pages/TrackingPageV2/components/TrackingReplayPageSkeleton';
import { createElement, Suspense } from 'react';

const TrackingPage = lazy(() => import('@cobliteam/tracking/src/pages/TrackingPage'));
const LazyTrackingReplayRouteGate = lazy(() => import('@cobliteam/tracking/src/pages/TrackingReplayRouteGate'));
const TrackingHistoryGatePage = lazy(() => import('@cobliteam/tracking/src/pages/TrackingHistoryGatePage'));

const TrackingReplayRouteGate = () => createElement(Suspense, { fallback: createElement(TrackingReplayPageSkeleton) }, createElement(LazyTrackingReplayRouteGate));

const routes = [
  {
    title: locationName[Location.TRACKING],
    path: Location.TRACKING,
    component: TrackingPage,
  },
  {
    title: locationName[Location.TRACKING_REPLAY],
    path: Location.TRACKING_REPLAY,
    component: TrackingReplayRouteGate,
  },
  {
    title: locationName[Location.TRACKING_HISTORY],
    path: Location.TRACKING_HISTORY,
    component: TrackingHistoryGatePage,
  },
];

export default routes;
